<template>
	<div class="table-view">
		<AgGridVue
			class="ag-theme-alpine"
			:columnDefs="headers"
			:rowData="rows"
			:statusBar="statusBar"
			v-bind="gridOptions"
			v-on="gridListeners"
			@grid-ready="onGridReady"
		>
		</AgGridVue>
		<div class="status-bar"><TableStatusBar :columnDefs="headers" :rows="rows" /></div>
	</div>
</template>

<script>
import TableStatusBar from './TableStatusBar';
const AgGridVue = () => import(/* webpackPrefetch: true */ 'ag-grid-vue').then((result) => result.AgGridVue);

export default {
	name: 'TableView',
	components: {
		AgGridVue,
		TableStatusBar,
	},
	props: {
		headers: { type: Array },
		rows: { type: Array },
		gridOptions: { type: Object, default: () => ({}) },
		gridListeners: { type: Object, default: () => ({}) },
	},
	beforeMount() {},
	methods: {
		onGridReady(params) {
			this.gridApi = params.api;
			this.gridColumnApi = params.columnApi;
			const exposedApi = {
				setSelectedRow: (rowIndex) => {
					params.api.forEachNode((node) => {
						if (node.rowIndex === rowIndex) {
							node.setSelected(true);
						}
					});
				},
			};
			params.api.sizeColumnsToFit();
			this.$emit('onGridReady', exposedApi);
		},
		onSelectionChanged() {
			const selectedRows = this.gridApi.getSelectedRows();
			this.$emit('onSelectionChanged', selectedRows);
		},
	},
	data() {
		return {
			gridApi: null,
			gridColumnApi: null,
			statusBar: null,
		};
	},
};
</script>
<style lang="scss">
@import '~ag-grid-community/dist/styles/ag-grid.css';
@import '~ag-grid-community/src/styles/ag-theme-alpine/sass/ag-theme-alpine-mixin.scss';
/* We are not scoping style component because it fucks up the imports of '@include ag-theme-alpine'  */
/*  We mannually scope it with the '.ag-theme-alpine' class */
/*  Which is ennough as long as we don't use ot anywhere else in our code base */

.table-view {
	$border-color: #dfe4ef;
	$border-radius: 6px;
	$status-bar-height: 30px;

	.ag-theme-alpine {
		width: 100%;
		height: calc(100% - #{$status-bar-height});

		@include ag-theme-alpine(
			(
				border-radius: $border-radius,
				border-color: $border-color,
				cell-horizontal-border: solid $border-color,
				header-height: 32px,
				row-height: 35px,
				cell-horizontal-padding: ag-derived(grid-size, $times: 1),
			)
		);

		.ag-header-cell {
			// or write CSS selectors to make customisations beyond what the parameters support
			border-right: 1px solid ag-param(secondary-border-color);
			background-color: ag-param(background-color) !important;
		}

		.ag-root-wrapper.ag-layout-normal {
			border-top-left-radius: $border-radius;
			border-top-right-radius: $border-radius;
			border-bottom-right-radius: 0;
			border-bottom-left-radius: 0;
		}

		.ag-header-cell-text {
			&::before {
				content: url("data:image/svg+xml; utf8, <svg xmlns='http://www.w3.org/2000/svg' width='10.996' height='9.516' viewBox='0 0 10.996 9.516'> <path id='Path_20121' data-name='Path 20121' d='M8.921,4.018A.423.423,0,0,0,8.5,3.6H.423A.423.423,0,0,0,0,4.018V4.9a.423.423,0,0,0,.423.423H8.5A.423.423,0,0,0,8.921,4.9ZM.423,1A.423.423,0,0,0,0,1.423v.884a.423.423,0,0,0,.423.423h10.15A.423.423,0,0,0,11,2.307V1.423A.423.423,0,0,0,10.573,1ZM0,7.5a.423.423,0,0,0,.423.423h9.3A.423.423,0,0,0,10.15,7.5V6.613a.423.423,0,0,0-.423-.423H.423A.423.423,0,0,0,0,6.613Zm0,2.6a.423.423,0,0,0,.423.423H8.035a.423.423,0,0,0,.423-.423V9.208a.423.423,0,0,0-.423-.423H.423A.423.423,0,0,0,0,9.208Z' transform='translate(0 -1)' fill='rgb(41, 40, 41)' opacity='0.5'/> </svg>");
				margin: 0 4px 0 0;
				width: 10px;
				height: 10px;
			}
		}
	}

	.status-bar {
		height: $status-bar-height;
		padding: 4px 16px;
		border: 1px solid $border-color;
		border-top-left-radius: 0;
		border-top-right-radius: 0;
		border-bottom-right-radius: $border-radius;
		border-bottom-left-radius: $border-radius;
		background-color: var(--primary-bg-color);
		font-size: 12px;
		font-weight: light;
		text-align: left;
	}
}
</style>
